import { useMatch } from "react-router-dom";
import * as paths from "ui/Router/paths";

export const useOrganizationId = () => {
  return useMatch(paths.companyWildcard)?.params?.id as string;
};
